import Button from '../Button/Button';
import { useState, useEffect } from 'react';

const SchoolCard = ({
  schoolName,
  description,
  location,
  subjectNo,
  schoolLogo,
  schoolHeader,
  selectSchool,
  lessonCount,
  page,
  type,
  activities,
  price,
  index,
}) => {
  const [bg, setBg] = useState('');

  useEffect(() => {
    if (index % 2) {
      setBg('#FFCC1D');
    } else if (index % 3) {
      setBg('#FFAEC0');
    } else {
      setBg('#9FECDB');
    }
  }, []);

  return (
    <div
      className='school-card'
      style={{
        boxShadow: `10px 10px 0px 0px ${bg}`,
        margin: '34px 0',
      }}
    >
      <img src={schoolHeader} alt='' className='school-card__school-img' />
      <div className='school-card__body'>
        <div className='school-card__body__top'>
          <div className='school-card__body__top__img-wrap'>
            <img src={schoolLogo} alt={schoolName} />
          </div>

          <div className='school-card__body__top__location'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M7.99996 7.99992C7.26663 7.99992 6.66663 7.39992 6.66663 6.66659C6.66663 5.93325 7.26663 5.33325 7.99996 5.33325C8.73329 5.33325 9.33329 5.93325 9.33329 6.66659C9.33329 7.39992 8.73329 7.99992 7.99996 7.99992ZM12 6.79992C12 4.37992 10.2333 2.66659 7.99996 2.66659C5.76663 2.66659 3.99996 4.37992 3.99996 6.79992C3.99996 8.35992 5.29996 10.4266 7.99996 12.8933C10.7 10.4266 12 8.35992 12 6.79992ZM7.99996 1.33325C10.8 1.33325 13.3333 3.47992 13.3333 6.79992C13.3333 9.01325 11.5533 11.6333 7.99996 14.6666C4.44663 11.6333 2.66663 9.01325 2.66663 6.79992C2.66663 3.47992 5.19996 1.33325 7.99996 1.33325Z'
                fill='#5A5955'
              />
            </svg>
            <p>{location}</p>
          </div>
        </div>
        <div className='school-card__body__title'>
          <h3 style={{ textTransform: 'capitalize' }}>
            {schoolName?.length > 20
              ? `${schoolName?.substring(0, 18)}...`
              : schoolName}
          </h3>
          <p>
            {' '}
            {!description
              ? 'No bio available'
              : description?.length > 100
              ? `${description?.substring(0, 80)}...`
              : description}
          </p>
        </div>
        <div className='school-card__body__flex'>
          <div className='school-card__body__flex__item'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M12.6667 3.33333V4.66667H10V3.33333H12.6667ZM6 3.33333V7.33333H3.33333V3.33333H6ZM12.6667 8.66667V12.6667H10V8.66667H12.6667ZM6 11.3333V12.6667H3.33333V11.3333H6ZM14 2H8.66667V6H14V2ZM7.33333 2H2V8.66667H7.33333V2ZM14 7.33333H8.66667V14H14V7.33333ZM7.33333 10H2V14H7.33333V10Z'
                fill='#5A5955'
              />
            </svg>
            <p style={{ fontSize: '14px' }}>
              {subjectNo}
              {type === 'tutor' ? ' topic(s)' : ' subject(s)'}
            </p>
          </div>

          <div className='school-card__body__flex__item'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z'
                fill='#5A5955'
              />
              <path
                d='M9.33366 11.3332H4.66699V9.99984H9.33366V11.3332ZM11.3337 8.6665H4.66699V7.33317H11.3337V8.6665ZM11.3337 5.99984H4.66699V4.6665H11.3337V5.99984Z'
                fill='#5A5955'
              />
            </svg>
            <p style={{ fontSize: '14px' }}>{lessonCount} Lessons</p>
            {/* {type !== 'tutor' && (
              <p style={{ fontSize: '14px' }}>{activities} Activities</p>
            )} */}
          </div>
        </div>
        {page !== 'dashboard' && (
          <div className='school-card__body__flex'>
            <div className='school-card__body__flex__item'>
              <p style={{ fontSize: '14px' }}>Year 9 (Grade 9)</p>
            </div>
          </div>
        )}

        <Button
          text={
            page === 'dashboard' && type === 'school'
              ? 'View School'
              : page === 'dashboard' && type === 'tutor'
              ? 'View Tutor'
              : 'Select School'
          }
          className='thick-orange-border'
          width='100%'
          onClick={selectSchool}
        />
      </div>
    </div>
  );
};

export default SchoolCard;
